import React, { useState, useEffect } from "react";
import {
    Card,
    CardHeader,
    CardContent,
    CardMedia,
    Checkbox,
    Modal,
    Select,
    MenuItem, TextField,
    Typography,
    Box,
    Stack,
    Avatar,
    AvatarGroup,
    Popover,
    IconButton,
    Button,
} from "@mui/material";
import Feedback from "../assets/landing_page/Icons/support.png";
import CloseIcon from "../assets/landing_page/new/closeicon.svg";
import tick from "../assets/landing_page/new/teenyicons_tick-circle-solid.svg";
import { toast } from "react-toastify";
import http from "../utils/http-common";
import Draggable from "react-draggable";
import ThreeDot from "react-loading-indicators/ThreeDot";
function FeedbackForm({ planData = [], getUsers }) {
    const [open1, setOpen1] = useState(false);
      const [loading, setLoading] = useState(false);
    const [feedbackModule, setFeedbackModule] = useState("Select Module Type");
    const [feedbackType, setFeedbackType] = useState("Select Feedback Type");
    const [comments, setComments] = useState("");
    const [isDragging, setIsDragging] = useState(false);
    const handleOpen = () => {
        if (!isDragging) setOpen1(true); // Only open if it's not being dragged
    };
    const handleClose = () => {
        setFeedbackModule("Select Module Type");
        setFeedbackType("Select Feedback Type");
        setComments("");
        setOpen1(false);
    };

    const handleSubmit = async () => {
        if (!feedbackModule || feedbackModule === "Select Module Type") {
            toast.error("Please select a feedback module.");
            return; // Prevent API call if module is empty
        }
    
        if (!feedbackType || feedbackType === "Select Feedback Type") {
            toast.error("Please select a feedback type.");
            return; // Prevent API call if feedback type is empty
        }
    
        if (!comments || comments.trim() === "") {
            toast.error("Please provide your feedback.");
            return; // Prevent API call if comments are empty
        }
        setLoading(true);
        try {
            const payload = {
                module: feedbackModule,
                subject: feedbackType,
                content: comments,
            };
            const response = await http.post("/master_service/feedback/send/data", payload);
            if (response.data.message === "Emails sent successfully") {
                setFeedbackModule("Select Module Type");
                setFeedbackType("Select Feedback Type");
                setComments("");
                setOpen1(false);
                toast.success(
                    <div
                        style={{
                            fontFamily: "Inter, sans-serif",
                            fontSize: "14px",
                            fontWeight: "600",
                            lineHeight: "24px",
                            textAlign: "left",
                            marginBottom: "8px",
                            marginTop: "10px",
                        }}>
                        Feedback submitted successfully
                    </div>,
                    {
                        icon: (
                            <img
                                src={tick}
                                alt='Success Icon'
                                style={{ width: "20px", height: "20px", color: "#0057D5" }}
                            />
                        ),
                    }
                );
            }
        }
        catch (error) {
            console.error("Error creating account", error);
            toast.error("Error submitting feedback. Please try again.");
        } finally {
            setLoading(false); // Stop loading regardless of success or failure
          }
    };
    return (
        <Box
            sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 0, // Adds spacing between items
                marginTop: "0px",
            }}>
            {/* Feedback Button (Bottom Right) */}
            <Draggable onStart={() => setIsDragging(false)} // Reset dragging state at the start
                onDrag={() => setIsDragging(true)} // Set dragging state during drag
                onStop={() => setTimeout(() => setIsDragging(false), 200)}>
                <Box
                    sx={{
                        position: "fixed",
                        bottom: "80px",
                        right: "20px",
                        zIndex: 1000,
                        cursor: "move", // Show move cursor
                    }}
                >
                    <Button
                        variant="contained"
                        onClick={handleOpen}
                        sx={{
                            borderRadius: "50px",
                            backgroundColor: "#FF2800",
                            padding: "10px 20px",
                            fontWeight: "bold",
                            boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                            textTransform: "none",
                            "&:hover": {
                                backgroundColor: "#FF2800",
                            },
                        }}
                    >
                        <img src={Feedback} height={16} width={16} alt="feedback" /> Give Feedback
                    </Button>
                </Box>
            </Draggable>
            {/* Feedback Modal */}
            <Modal open={open1} onClose={handleClose}>
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: "600px",
                        bgcolor: "background.paper",
                        boxShadow: 24,
                        p: 4,
                        borderRadius: "10px",
                    }}
                >
                    {/* Close Icon */}
                    <IconButton
                        onClick={handleClose}
                        sx={{
                            position: "absolute",
                            top: 8,
                            right: 8,
                            color: "grey",
                        }}
                    >
                        <img
                            src={CloseIcon}
                            alt='closeIcon'
                            style={{ width: "25px", height: "25px" }}
                        />
                    </IconButton>
                    <Typography variant="h6" style={{ fontWeight: 600 }} gutterBottom>
                        Feedback Form
                    </Typography>
                    <br />
                    <Typography variant="h6" style={{ fontWeight: 600 }} gutterBottom>
                        We Value Your Feedback
                    </Typography>

                    <Typography gutterBottom>
                        Your insights help us improve PlanShare.ai for you and everyone else.
                    </Typography>
                    <br />
                    {/* Feedback Type */}
                    <Typography style={{ fontSize: "12px", fontWeight: 600 }} gutterBottom>
                        Module Type
                    </Typography>

                    <Select
                        fullWidth
                        value={feedbackModule}
                        onChange={(e) => setFeedbackModule(e.target.value)}
                        sx={{ mb: 2, height: "40px", borderColor: "lightgrey" }}
                    ><MenuItem value="Select Module Type" disabled>
                            Select Module Type
                        </MenuItem>
                        <MenuItem value="My Plans">My Plans</MenuItem>
                        <MenuItem value="Users">Users</MenuItem>
                        <MenuItem value="Share Plan">Share Plan</MenuItem>
                        <MenuItem value="Analysis">Analysis</MenuItem>
                        <MenuItem value="Reports">Reports</MenuItem>
                        <MenuItem value="Subscription">Subscription</MenuItem>
                        <MenuItem value="Templates">Templates</MenuItem>
                        <MenuItem value="Videos">Videos</MenuItem>
                        <MenuItem value="Others">Others</MenuItem>
                    </Select>
                    <Typography style={{ fontSize: "12px", fontWeight: 600 }} gutterBottom>
                        Feedback Type
                    </Typography>
                    <Select
                        fullWidth
                        value={feedbackType}
                        placeholder="Select Feedback Type"
                        onChange={(e) => setFeedbackType(e.target.value)}
                        sx={{ mb: 2, height: "40px", borderColor: "lightgrey" }}
                    ><MenuItem value="Select Feedback Type" disabled>
                            Select Feedback Type
                        </MenuItem>
                        <MenuItem value="Feature Request">Feature Request</MenuItem>
                        <MenuItem value="Ask a question">Ask a question</MenuItem>
                        <MenuItem value="Leave a comment">Leave a comment</MenuItem>
                        <MenuItem value="Report bug">Report bug</MenuItem>
                        <MenuItem value="Suggest an improvement">Suggest an improvement</MenuItem>
                        <MenuItem value="Others">Others</MenuItem>
                    </Select>
                    <Typography style={{ fontSize: "12px", fontWeight: 600 }} gutterBottom>
                        Message
                    </Typography>
                    {/* Comments */}
                    <TextField
                        fullWidth
                        multiline
                        rows={4}
                        placeholder="Leave your thoughts here..."
                        value={comments}
                        onChange={(e) => setComments(e.target.value)}
                        sx={{ mb: 2, borderColor: "lightgrey" }}
                    />

                    {/* Submit Button */}
                    <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                        <Button
                            variant="outlined"
                            onClick={handleClose}
                            sx={{
                                mr: 2,
                                color: "black",
                                borderColor: "black",
                                textTransform: "capitalize",
                                cursor: "pointer"
                            }}
                        >
                            Back
                        </Button>
                        <Button
                            variant="contained"
                            style={{
                                backgroundColor: "#FF2800",
                                color: "white",
                                textTransform: "capitalize",
                                cursor: "pointer"
                            }}
                            onClick={handleSubmit}
                            //disabled={!feedbackModule || !feedbackType || !comments.trim()}
                            disabled={loading}>
                            {loading ? (
                              <ThreeDot variant='pulsate' color='#FF2800' size='small' />
                            ) : (
                              "Send"
                            )}
                        </Button>
                    </Box>
                </Box>
            </Modal>
        </Box>
    );
}

export default FeedbackForm;